(() => {
  if (customElements.get('sr-product-carousel')) return;
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.sr-carousel-track');
      this.slides = [...this.querySelectorAll('.sr-carousel-slide')];
      this.index = 0;
      this.querySelectorAll('[data-carousel-dot]').forEach(b => b.addEventListener('click', () => this.go(Number(b.dataset.carouselDot))));
      this.querySelectorAll('[data-carousel-prev]').forEach(b => b.addEventListener('click', () => this.go(this.index - 1)));
      this.querySelectorAll('[data-carousel-next]').forEach(b => b.addEventListener('click', () => this.go(this.index + 1)));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update(Math.round(this.track.scrollLeft / this.track.clientWidth)));
      }, { passive: true });
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.resizeObserver = new ResizeObserver(() => this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' }));
      this.resizeObserver.observe(this.track);
      this.update(0);
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); cancelAnimationFrame(this.frame); this.ready = false; }
    go(value) {
      const next = Math.max(0, Math.min(this.slides.length - 1, value));
      this.update(next);
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'instant' });
    }
    update(value) {
      const previous = this.index;
      this.index = Math.max(0, Math.min(this.slides.length - 1, value));
      if (previous !== this.index) window.SeoulRootAnalytics?.send('sr_image_view', {
        sr_product: this.dataset.analyticsProduct,
        sr_detail: this.slides[this.index]?.dataset.slideKind || ['hero', 'benefits', 'who', 'ingredients', 'use'][this.index]
      });
      this.querySelector('[data-carousel-prev]').disabled = this.index === 0;
      this.querySelector('[data-carousel-next]').disabled = this.index === this.slides.length - 1;
      this.querySelectorAll('[data-carousel-dot]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.carouselDot) === this.index)));
      this.querySelector('[data-carousel-status]').textContent = `Image ${this.index + 1} of ${this.slides.length}`;
    }
  }
  customElements.define('sr-product-carousel', ProductCarousel);
})();
